import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_22: FaireProductEntity = {
  token: "catalog_prod_prod-22",
  type: "product",
  name: "Balloon Garland Kit - Pastel Rainbow - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 79.24,
  msrpDollars: 198.1,
  sku: "CO0022",
  caseSize: 3,
  material: "Cotton",
  collectionToken: "col_confetti-cake",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 271,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_games-puzzles"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
